import {ParseResult, ParseUtils} from "bryx-cereal";

export class Nothing {
    static readonly shared = new Nothing();
    static parse(o: any): ParseResult<Nothing> {
        return ParseUtils.parseSuccess(Nothing.shared);
    }
}
